/* Do two rows of a Combined Resource join on this pair of values?

   The join used `===`, and two APIs rarely agree on a key's type: one sends
   BrandID as 12, the other as "12". Strict equality matched nothing, the join
   produced no rows, and the chart built on it drew empty. Values are compared
   as text instead, so 12 and "12" match.

   An empty key (null, undefined, "") never matches. `===` used to pair every
   row missing the field with every row of the other resource missing it too,
   which is a cross product, not a join. */
export function joinValuesMatch(a, b) {
  if (a === null || a === undefined || a === "") return false;
  if (b === null || b === undefined || b === "") return false;
  return String(a).trim() === String(b).trim();
}
